import 'i18next';
import { IsNotEmpty } from 'class-validator';

import { t } from '@app-velocity/i18n';

export class NewReviewDto {
  @IsNotEmpty({
    message: t('appraisals:review_error.you_must_select_page'),
  })
  method = '';

  @IsNotEmpty({
    message: t('appraisals:review_error.you_must_choose_method'),
  })
  page = '';

  level = '';
}
